import React from "react";

const PartyCategory = ({
  onClickFn = () => {},
  width = "23",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3246_130)">
<path d="M8.125 3.125C8.125 2.08984 8.96484 1.25 10 1.25H12.5C13.5352 1.25 14.375 2.08984 14.375 3.125V5.625C14.375 6.66016 13.5352 7.5 12.5 7.5H12.1875V9.0625H18.125C19.332 9.0625 20.3125 10.043 20.3125 11.25V12.5H20.625C21.6602 12.5 22.5 13.3398 22.5 14.375V16.875C22.5 17.9102 21.6602 18.75 20.625 18.75H18.125C17.0898 18.75 16.25 17.9102 16.25 16.875V14.375C16.25 13.3398 17.0898 12.5 18.125 12.5H18.4375V11.25C18.4375 11.0781 18.2969 10.9375 18.125 10.9375H12.1875V12.5H12.5C13.5352 12.5 14.375 13.3398 14.375 14.375V16.875C14.375 17.9102 13.5352 18.75 12.5 18.75H10C8.96484 18.75 8.125 17.9102 8.125 16.875V14.375C8.125 13.3398 8.96484 12.5 10 12.5H10.3125V10.9375H4.375C4.20312 10.9375 4.0625 11.0781 4.0625 11.25V12.5H4.375C5.41016 12.5 6.25 13.3398 6.25 14.375V16.875C6.25 17.9102 5.41016 18.75 4.375 18.75H1.875C0.839844 18.75 0 17.9102 0 16.875V14.375C0 13.3398 0.839844 12.5 1.875 12.5H2.1875V11.25C2.1875 10.043 3.16797 9.0625 4.375 9.0625H10.3125V7.5H10C8.96484 7.5 8.125 6.66016 8.125 5.625V3.125Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3246_130">
<path d="M0 0H22.5V20H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default PartyCategory;